//import { getSession, signOut } from '@/com/services/services.auth'
import axios from  'axios'
const MUTATE_TOKENS = 'mutateTokens'
const CLEAR_AUTH = 'clearAuth'

const state = {
  accessToken: '',
  idToken: '',
  refreshToken: '',
  isAuthenticated: false,
}

const getters = {
  isAuthenticated: state => state.isAuthenticated
}

const mutations = {
  mutateIsAuthenticated (state, bool) {
    state.isAuthenticated = bool
  },
  mutateTokens(state, { accessToken, idToken }) {
    state.accessToken = accessToken
    state.idToken = idToken
    state.isAuthenticated = true
  },
  clearAuth(state) {
    state.accessToken = ''
    state.idToken = ''
    state.isAuthenticated = false
  }
}

const actions = {
  async refreshSession({ commit }) {
    try {
      const response = await axios.post('/auth/refresh', {
        refreshToken: state.refreshToken
      })

      commit(MUTATE_TOKENS, {
        accessToken: response.data.accessToken,
        idToken: response.data.idToken,
        // only update refresh token if returned
        refreshToken: response.data.refreshToken || state.refreshToken
      })
    } catch (err) {
      commit(CLEAR_AUTH)
      throw err
    }
  },
  setTokens({ commit }, tokens) {
    commit(MUTATE_TOKENS, tokens)
  },
  setIsAuthenticated ({ commit }, bool) {
    commit('mutateIsAuthenticated', bool)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}